export enum MediaType {
  IMAGE = 'IMAGE',
  SEATMAP = 'SEATMAP',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  STREAMING = 'STREAMING',
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/model/media-type.ts